//@vendor
const React = require('react');
const PropTypes = require('prop-types');
//@core
const { FormattedText } = require('core/i18n').i18n;
//@components
const RequestMortgageTable = require('./requestMortgageTable');
// @const
const keyPrefix = 'calculateQuotaMixedMortgageTable-calculateQuotaMixedMortgageTable_';

const MixedMortgageTable = props => {
    const {
        isMortgageTableEnabled,
        noConditions,
        showBuildedTable,
    } = props;
    const keySufix = noConditions ? 'NoConditions' : '';

    const bodyValues = [
        [
            'calculateQuotaHeader-calculateQuotaHeader_financeUp50',
            '50TIN10YearsFixed',
            '50TINVariableRemainingYears',
            '50TAEVariable',
        ],
        [
            'calculateQuotaHeader-calculateQuotaHeader_financeUp70',
            '70TIN10YearsFixed',
            '70TINVariableRemainingYears',
            '70TAEVariable',
        ],
    ];

    const cellsBodyConfiguration = bodyValues.map((row) => row.map((cell, index) => ({
        asHeader: false,
        className: index === 0 ? 'mortgage-request-header-calculate-quota__table-container-mixed__body__row__financial-percent' :
            'mortgage-request-header-calculate-quota__table-container-mixed__body__row__value',
        value: <FormattedText value={index === 0 ? cell : `${keyPrefix}${cell}${keySufix}`}/>
    })));

    const cellsHeaderConfiguration = [
        <span>&nbsp;</span>,
        <FormattedText value={`${keyPrefix}headerTIN10YearsFixed`}/>,
        <FormattedText value={`${keyPrefix}headerTINVariableRemainingYears`}/>,
        <FormattedText value="calculateQuotaHeader-calculateQuotaHeader_TAEVariable"/>,
    ];

    return (
        <RequestMortgageTable
            cellsBodyConfiguration={cellsBodyConfiguration}
            cellsHeaderConfiguration={cellsHeaderConfiguration}
            isMortgageTableEnabled={isMortgageTableEnabled}
            noConditions={noConditions}
            showBuildedTable={showBuildedTable}
            type='mixed'
            hideTitleSubtitle={true}
        ></RequestMortgageTable>
    )
}

MixedMortgageTable.propTypes = {
    showBuildedTable: PropTypes.bool.isRequired,
    isMortgageTableEnabled: PropTypes.bool.isRequired,
    noConditions: PropTypes.bool.isRequired,
}

module.exports = MixedMortgageTable;
